import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import IMG1 from "../../../images/industries/logistics/UX-Focused-Development.webp";
import IMG2 from "../../../images/industries/logistics/Maintenance-Support.webp";
import IMG3 from "../../../images/industries/logistics/Quick-Turnarounds.webp";
import IMG4 from "../../../images/industries/logistics/Flexibility.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Demandfeatures(props) {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";
  return (
    <section className="tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Fintech Software">
              <h2>
                Why Choose Us As Your Custom Logistics Software Development
                Company?
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              We strongly emphasize building UX-focused logistics software
              applications with intuitive user interface design and easy-to-use
              features.We follow an agile development methodology to maintain
              high-quality standards and keep our partners and stakeholders
              involved throughout the development phase.
            </p>
            <p>
              Our approach from building a software development roadmap to
              project deployment and integration stays constant, i.e., to
              deliver maximum value to the end user. As a leading logistics
              software development company, we prioritize the user experience
              above all and make no compromise on quality.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                0,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(0)}
            >
              <LazyLoadImage
                src={IMG1}
                effect="blur"
                alt="IMG1"
                className="img-fluid"
              />
              <h6>Focused Development</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                1,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(1)}
            >
              <LazyLoadImage
                src={IMG2}
                effect="blur"
                alt="IMG2"
                className="img-fluid"
              />
              <h6>Maintenance & Support</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                2,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(2)}
            >
              <LazyLoadImage
                src={IMG3}
                effect="blur"
                alt="IMG3"
                className="img-fluid"
              />
              <h6>Quick Turnarounds</h6>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2}>
            <div
              className={`industries_boxes hover01 ${getActiveClass(
                3,
                "active-tabs"
              )}`}
              onClick={() => toggleTab(3)}
            >
              <LazyLoadImage
                src={IMG4}
                effect="blur"
                alt="IMG4"
                className="img-fluid"
              />
              <h6>Flexibility</h6>
            </div>
          </Col>

          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 0
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Our approach from building a software development roadmap to
              project deployment and integration stays constant, i.e., to
              deliver maximum value to the end user. As a leading logistics
              software development company, we prioritize the user experience
              above all and make no compromise on quality.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 1
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              Our PMP-Certified project managers and key account executives
              ensure 24/7 support to our clients to quickly address their
              concerns. We provide dedicated development teams to our clients to
              maintain their logistics software, regardless of the workload.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 2
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              We understand how crucial it is to have reliable logistics
              software to enhance operational efficiencies and eliminate the
              chances of inaccuracies. Thus, we strive to set short but
              realistic project deadlines and strongly emphasize delivering the
              project on time.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <p
              className={
                toggleState === 3
                  ? "industries_content d-block"
                  : "content d-none"
              }
            >
              At TekRevol, we build class-apart logistics software applications
              that support access to smartphones and tablets. We empower
              logistic companies to streamline operations and build logistics
              software solutions tailored to their business needs.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Demandfeatures;
